import { render, staticRenderFns } from "./isi_kegiatan.vue?vue&type=template&id=03259f81&"
import script from "./isi_kegiatan.vue?vue&type=script&lang=js&"
export * from "./isi_kegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports